<template>
<div>
    <CRow class="pt-4 pb-4 pl-4 pr-4">
        <CCol sm="12">
            <div class="autocomplete">
                <input type="text"
                        class="form-control"
                        @click="toggleVisiblePegawai()"
                        @blur="toggleCloseVisiblePegawai()"
                        v-model="queryPegawai"
                        v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                        @keydown.up="upPegawai"
                        @keydown.down="downPegawai"
                        @keydown.enter="selectItemPegawai"
                        placeholder="Pilih Pegawai"
                >
                <div class="popovers" v-show="visiblePegawai">
                    <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                        <ul>
                        <li v-for="(match, index) in matchesPegawai"
                            :key="index"
                            :class="{ 'selected': (selectedPegawai == index)}"
                            @click="itemClickedPegawai(index)"
                            v-text="match['text']"></li>
                        </ul>
                    </div>
                    <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                        Data Tidak Ditemukan
                    </div>
                    <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                        Start Typing...
                    </div>
                </div>
            </div>
        </CCol>
        <CCol sm="12" class="mt-2">
            <textarea class="form-control" v-model="header" placeholder="Header" rows="3"></textarea>
        </CCol>
        <CCol sm="12" class="mt-2">
            <textarea class="form-control" v-model="message" placeholder="Message" rows="3"></textarea>
        </CCol>
        <CCol sm="4" class="mt-3">
            <CButton @click="send()" type="button" class="btn btn-primary">Send</CButton>
        </CCol>
        <CCol sm="8">
            {{response}}
        </CCol>
    </CRow>
</div>
</template>
<script>
import {DataApi} from "../../../service/DataApi";
export default {
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            header: '',
            message: '',
            response: '',
        }
    },
    methods: {
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        send() {
            this.response = ''
            let payload = {
                header: this.header,
                idPegawai: this.idPegawai,
                pesan: this.message
            }
            DataApi.post("pegawai/push/notif", payload)
            .then(res => {
                this.response = res.data.success
                this.idPegawai = ''
                this.queryPegawai = ''
                this.header = ''
                this.message = ''
            })
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    watch: {
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
            }
            this.getDataPegawai()
        },
    },
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>